import { FeatureFlags } from '../../../api/features.service';
import { SpendAndSavingsSummary } from '../../format/spendAndSavingsSummary.filter';

/*
 * @name: SpendAndSavingsSummaryComponent
 * @description: component for displaying, continuedSpend,
 * complianceSpend, plannedSpend, savings, savingsPercent, and excludedSpend
 * @usage: <spend-and-savings-summary>
 * @important: this makes use of the SpendAndSavingsSummary filter
 * */
class spendAndSavingsSummaryCtrl {
  static bindings = {
    continuedSpend: '<',
    continuedSpendVisibility: '<',
    complianceSpend: '<',
    featureList: '<',
    plannedSpend: '<'
  };

  continuedSpend: number;
  continuedSpendVisibility: boolean;
  complianceSpend: number;
  plannedSpend: number;
  savings: number;
  savingsPercent: number;
  excludedSpend: number;

  spendAndSavingSummaryFilter;

  featureList: FeatureFlags;

  constructor($filter) {
    'ngInject';

    this.spendAndSavingSummaryFilter = $filter('spendAndSavingsSummary');
  }

  $onChanges() {
    const {
      savings,
      savingsPercent,
      excludedSpend
    } = this.spendAndSavingSummaryFilter(
      this.continuedSpend,
      this.plannedSpend,
      this.complianceSpend
    ) as SpendAndSavingsSummary;

    this.savings = savings;
    this.savingsPercent = savingsPercent;
    this.excludedSpend = excludedSpend;
  }
}

export const SpendAndSavingsSummaryComponent = {
  template: require('./spendAndSavingsSummary.component.html'),
  controller: spendAndSavingsSummaryCtrl,
  bindings: spendAndSavingsSummaryCtrl.bindings
};
